import '../../App.css';
import '../../Css/Description.css';
import '../../Css/TTContent.css';


export default function DescriptionTT() {

  return (
    
    <div className='ttContainer'>
        <div className='ttTitleContainer'>
            {/* <div className='ttTitle'>Qui sommes nous ?</div>
            <div className='tt-hl-container'><div className='tt-horizontal-line'></div></div> */}
        </div>
        <div className='tt-desc-container'>
        <img className='tt-logo' alt='LogoTrans' src='./images/logo/Logo Astraya Beige.png'></img>
        <div className='descTT'>
            <p id='ttBienvenue'>Informatique <span id='tt-nom'>sur mesure</span> !</p>chez <span id='tt-nom'>Astraya</span>, nous avons une mission simple: rendre l’informatique facile et accessible à tous. 
            Besoin de créer un site web pour booster votre activité ? 
            D’un dépannage express pour votre matériel informatique ? Ou d’un réseau qui marche sans prise de tête ? 
            Nous nous occupons de tout ça, et plus encore. Avec une approche humaine et personnalisée, 
            pas de jargon compliqué ici, juste des solutions concrètes et adaptées. Alors, si nous pouvons vous aider, nous sommes à votre service !
        </div>
      </div>  
    </div>
    
  );
}